<template>
  <v-container text-xs-center>
    <v-layout row>
      <v-dialog v-model="loading" :retain-focus="false" persistent fullscreen>
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="70"
              :width="7"
              color="secondary"
            >
            </v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <v-flex xs12>
      <v-carousel
        v-if="!loading && drillLib.edges.length > 0"
        v-bind="{ cycle: true }"
        interval="3000"
      >
        <v-carousel-item
          v-for="edge in drillLib.edges"
          :key="edge.node.drillId"
          :src="edge.node.videoUrl"
        >
          <h1 id="carousel__title">{{ edge.node.drillName }}</h1>
        </v-carousel-item>
      </v-carousel>
    </v-flex>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "home",
  created() {
    this.handleGetDrillsPosts();
  },
  computed: {
    ...mapGetters(["loading", "drillLib"])
  },
  methods: {
    handleGetDrillsPosts() {
      //reach out of Vuex store, fire action that gets posts for carousel
      this.$store.dispatch("allDrillLib");
    }
  }
};
</script>

<style>
#carousel__title {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border-radius: 5px 5px 0 0;
  padding: 0.5em;
  margin: 0 auto;
  bottom: 50px;
  left: 0;
  right: 0;
}
</style>
